import { Injectable } from '@angular/core';
import { DocumentReference } from '@angular/fire/firestore';
import { FireStoreCollection } from '@shared/models/firestore';
import { ILeadRequestConfirmationMail, IMail, MailTemplate } from '@shared/models/mail';

import { FirestoreService } from '../firestore/firestore.service';

@Injectable({
	providedIn: 'root',
})
export class EmailService extends FirestoreService<IMail> {
	constructor() {
		super(FireStoreCollection.MAIL);
	}
	async leadRequestConfirmation(email: string, leadRequestConfirmation: ILeadRequestConfirmationMail): Promise<DocumentReference<IMail>> {
		return this.create({
			to: [email],
			from: `${leadRequestConfirmation.organisationName} <noreply@serveox.com>`,
			template: {
				name: MailTemplate.LEAD_REQUEST_SUBMISSION,
				data: leadRequestConfirmation,
			},
		});
	}
}
